// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__1J6f2"};